import { apiClient } from '@/core/api/client';

export type CarePlan = {
  id: string;
  session_id: string | null;
  plan_name: string;
  plan_description: string;
  status: string;
  created_at: string;
};

export async function fetchCarePlans(): Promise<CarePlan[]> {
  const response = await apiClient.get<CarePlan[]>('/navigator/care-plans');
  return response.data;
}
